export const formatPaisaToRupees = (paisa, options = {}) => {
  const { fractionDigits } = options;
  const numeric = Number(paisa);
  if (!Number.isFinite(numeric)) {
    return fractionDigits != null
      ? `₹${(0).toLocaleString("en-IN", {
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
        })}`
      : "₹0";
  }

  const rupees = numeric / 100;
  if (fractionDigits != null) {
    return `₹${rupees.toLocaleString("en-IN", {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    })}`;
  }

  return `₹${rupees.toLocaleString("en-IN")}`;
};

export const formatCount = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "0";
  return numeric.toLocaleString("en-IN");
};
